import { LinearProgress } from '@mui/material';

export const LoadingDialog = ({ children }: { children?: React.ReactNode },
) => {
  return (
    <div style={{ margin: 0 }}>
      <LinearProgress sx={{ height: '20px' }}/>
      <div style={{ margin: 8 }}>{children}</div>
    </div>
  );
};

export default LoadingDialog;
